(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/shared-components/scam-warning.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/shared-components/scam-warning.js');
'use strict';

const HREF = 'https://om.svenskaspel.se/bedragerier-allt-vanligare-var-pa-din-vakt/';
const ScamWarning = () => {
  const handleClick = e => {
    e.preventDefault();
    svs.components.analytics.trackEvent({
      category: 'Users',
      action: 'Login Failure',
      opt_label: 'Logg_in_own_initiativ_readmore'
    }, () => {
      svs.utils.url.navigate(HREF);
    });
  };
  return React.createElement("p", {
    className: svs.core.detect.feature('ft-bankid-secure-start') ? 'margin-top-1' : 'margin-top-2'
  }, "T\xE4nk p\xE5! N\xE4r du loggar in ska det alltid vara p\xE5 ditt eget initiativ.", React.createElement("br", null), React.createElement("a", {
    className: "f-inverted u-text-decoration-underline",
    href: HREF,
    onClick: handleClick
  }, "L\xE4s mer om hur du loggar in s\xE4kert"));
};
svs.playerLogin.sharedComponents.ScamWarning = ScamWarning;

 })(window);